import { useEffect, useMemo, useState } from 'react';
import Auth0SDK from 'utils/Auth0SDK';
import { Helmet } from 'react-helmet';

const LoginRedirect = () => {
  const [params, setParams] = useState({});

  const queryParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [window.location.search],
  );

  useEffect(() => {
    const queryObject = {};
    queryParams.forEach((entry, key) => {
      if (key.startsWith('utm_')) {
        Object.assign(queryObject, { [key]: entry });
      }
    });
    setParams(queryObject);
  }, [window.location.search]);

  useEffect(() => {
    Auth0SDK.authorize({
      body: {
        body: {
          hostname: window.location.hostname,
          tracking_params: params,
        },
      },
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Capitalise: Login to your account</title>
        <meta
          name="description"
          content="Login to your account to access business credit scores and find funding from 100+ lenders"
        />
      </Helmet>
    </>
  );
};

export default LoginRedirect;
